// 顶级状态

export const SET_DEBUG = 'SET_DEBUG'; // debug

export const SET_TITLE = 'SET_TITLE'; // 标题

export const SET_SHARE_WECHAT = 'SET_SHARE_WECHAT'; // 微信分享遮罩层

export const SET_VISIBLE_TOP = 'SET_VISIBLE_TOP'; // 顶部导航栏

export const SET_NAVIGATION_APP = 'SET_NAVIGATION_APP'; // 打开APP导航栏

export const SET_HIDE_TOP_ROUTERS = 'SET_HIDE_TOP_ROUTERS'; // 隐藏顶部导航栏路由

// =============  user userInfo 用户状态  =============

export const USER_USERINFO_CLEAR = 'USER_USERINFO_CLEAR'; // 用户信息清除

export const USER_USERINFO_UPDATE = 'USER_USERINFO_UPDATE'; // 用户信息更新

// =============  user register 用户注册信息状态  =============

export const USER_REGISTER_CLEAR = 'USER_REGISTER_CLEAR'; // 注册信息清除

export const USER_REGISTER_UPDATE = 'USER_REGISTER_UPDATE'; // 注册信息更新

// =============  user register wechat 微信用户信息绑定  =============

export const USER_REGISTER_WECHAT_CLEARN = 'USER_REGISTER_WECHAT_CLEARN'; // 微信注册信息清除

export const USER_REGISTER_WECHAT_UPDATE = ''; // 微信注册信息清除

// =============  user register wechat 微信用户信息绑定  =============

export const SERVICE_HAPPY_ORDER_CLEAR = 'SERVICE_HAPPY_ORDER_CLEAR'; // 无优服务订单列表清除
export const SERVICE_HAPPY_ORDER_UPDATE = 'SERVICE_HAPPY_ORDER_UPDATE'; // 无优服务订单列表更新

export const SERVICE_REPAIR_CLEAR = 'SERVICE_REPAIR_CLEAR'; // 报修清除
export const SERVICE_REPAIR_UPDATE = 'SERVICE_REPAIR_UPDATE'; // 报修更新

export const INVOICE_ROW_UPDATE = 'INVOICE_ROW_UPDATE'; // 发票选择更新

// ========   年报2022   =========
export const REPORT2022_SOURCES_UPDATE = 'REPORT2022_SOURCES_UPDATE';
export const REPORT2022_DETAIL_UPDATE = 'REPORT2022_DETAIL_UPDATE';
export const REPORT2022_FORM_UPDATE = 'REPORT2022_FORM_UPDATE';

// ========   年报2024   =========
export const REPORT2024_SOURCES_UPDATE = 'REPORT2024_SOURCES_UPDATE';
export const REPORT2024_DETAIL_UPDATE = 'REPORT2024_DETAIL_UPDATE';
export const REPORT2024_FORM_UPDATE = 'REPORT2024_FORM_UPDATE';

// ========   年报2025   =========
export const REPORT2025_SOURCES_UPDATE = 'REPORT2025_SOURCES_UPDATE';
export const REPORT2025_DETAIL_UPDATE = 'REPORT2025_DETAIL_UPDATE';
export const REPORT2025_FORM_UPDATE = 'REPORT2025_FORM_UPDATE';

// 解绑资料
export const UNBIND_INFO_UPDATE = 'UNBIND_INFO_UPDATE';
// 解绑原资料
export const UNBIND_ORIGIN_INFO_UPDATE = 'UNBIND_ORIGIN_INFO_UPDATE';
